<template>
  <div class="cleed-brands">
    <div class="cleed-brands-sizer"></div>
    <div
      v-for="(brand, idx) in brandsFromParent"
      :key="idx"
      class="cleed-brands-item"
      :class="{ 'brand-selected': brand.selected }"
      @click="addBrand($event, brand)"
    >
      <p>{{ $t(brand.name) }}</p>
    </div>
  </div>
</template>

<script>
import Masonry from "masonry-layout";

export default {
  name: "Brands",
  props: ["brands"],
  data() {
    return {
      savedBrand: [],
      brandsFromParent: [],
    };
  },
  beforeMount() {
    this.brandsFromParent = this.brands.map((brand) => {
        return {
          name: brand.name || brand,
          selected: (this.$store.state.user.data.brands && this.$store.state.user.data.brands.includes(brand)) ||
              (this.$store.state.user.data.material && this.$store.state.user.data.material.includes(brand))
      };
    });
  },
  mounted() {
    const msnry = new Masonry(".cleed-brands", {
      itemSelector: ".cleed-brands-item",
      columnWidth: ".cleed-brands-sizer",
      percentPosition: true,
    });
  },
  methods: {
    addBrand(event, brand) {
      brand.selected = !brand.selected;

      if (!this.$store.state.user.data.tmp_content)
          this.$store.commit("UPDATE_DATA", { tmp_content: [] });
      if (this.$store.state.user.data.tmp_content.indexOf(brand.name) !== -1) {
        this.$store.state.user.data.tmp_content =
          this.$store.state.user.data.tmp_content.filter((val) => val != brand.name);
      } else {
        this.$store.state.user.data.tmp_content.push(brand.name);
      }
    },
  },
};
</script>
